module.exports = __webpack_public_path__ + "static/media/Fig-6-14a.0353c371.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-6-14a.svg
// module id = 718
// module chunks = 0